import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { logos, title, description, link, implementation_link } = props;

	return (
		<React.Fragment>
			<div className="project">
				<Link to={link} target="_blank" rel="noopener noreferrer">
					<div className="project-container">
						<div className="project-logo">
							{logos.map((logo, index) => (
								<img src={logo} key={index} alt="logo" />
							))}
						</div>
						<div className="project-title-row">
							<div className="project-title">{title}</div>
							{implementation_link != null && (
								<Link
									className="project-implementation-link"
									to={implementation_link}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src="https://www.svgrepo.com/show/223032/playstore.svg"
										height={15}
										alt="play store"
									/>
								</Link>
							)}
						</div>
						<div className="project-description">{description}</div>
						<div className="project-link">
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</div>

							<div className="project-link-text">
								View Project
							</div>
						</div>
					</div>
				</Link>
			</div>
		</React.Fragment>
	);
};

export default Project;
